// ----------------------------------------------------------------------
// <copyright file="Izenda.NameInput.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = require('mobx-react').propTypes;
  var EventsUtils = require('EventUtils');
  var notifyChange = EventsUtils.notifyChange;
  var connect = require('share/enhancers/Izenda.Connect');
  var routeUtils = require('share/utils/Izenda.RouteUtils');

  var Link = require('react-router').Link;
  var Input = require('share/components/controls/Izenda.Input');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var uiState = require('logic/Izenda.UiState');
  var ValidatableInput = Validator()(Input);
  const { trim } = require('lodash/fp');
  var NameInput = React.createClass({
    propTypes: {
      dashboardPart: ObservablePropTypes.observableObject.isRequired,
      dashboardDetail: ObservablePropTypes.observableObject.isRequired,
      viewMode: PropTypes.bool
    },
    getInitialState: function() {
      return {
        editMode: false
      };
    },
    render: function() {
      var typeConfig = this.props.dashboardPart.typeConfig;

      return (
        <span>
          <i className={typeConfig.icon} />
          <span>
            {this.renderName()}
            {this.renderIcon()}
          </span>
        </span>
      );
    },
    /**
     * render dashboard Part name
     * @method renderName
     * @return {React Componenet}
     */
    renderName: function() {
      var props = this.props;
      var dashboardPart = props.dashboardPart;
      var dashboardDetail = props.dashboardDetail;
      var edit = !props.viewMode;
      var truncateText = String.truncateString(dashboardPart.title, 17);

      var inputTitleValidation = {
        action: function() {
          return dashboardDetail.validateNewNameDashboardPart.bind(
            dashboardDetail,
            dashboardPart,
            dashboardPart.editingTitle
          );
        }
      };

      if ((edit && dashboardPart.isBackSide) || this.state.editMode) {
        return (
          <ValidatableInput
            containerClassName="u_inlineBlock u_alignMiddle"
            className="form-control"
            field={'inputTitle_' + dashboardPart.id}
            validations={inputTitleValidation}
            value={dashboardPart.editingTitle}
            onChange={notifyChange(this.updateInputTitle, EventsUtils.INPUT)}
            onBlur={dashboardPart.isBackSide && this.renamePart}
          />
        );
      }
      if (dashboardPart.isReportPartType) {
        return (
          <a onClick={this.onNameClick} href="#">
            <span title={dashboardPart.title}>{truncateText}</span>
          </a>
        );
      }
      return <span title={dashboardPart.title}>{truncateText}</span>;
    },

    /**
     * check dirty before user navigate to report part link
     * @method onNameClick
     */
    onNameClick: function(e) {
      e.preventDefault();
      const props = this.props;
      const isDirty = props.dashboardPart.isDirty || props.dashboardDetail.isDirty;
      const url = routeUtils.getReportUrl('View', { id: props.dashboardPart.reportId });
      props
        .confirmDirtyForm(isDirty, {
          onConfirmDirtyForm: uiState.onOkDirtyForm
        })
        .then(function() {
          props.router.push(url);
        });
    },
    /**
     * render dashboard Part name icon
     * @method renderIcon
     * @return {React Componenet}
     */
    renderIcon: function() {
      var props = this.props;
      var dashboardPart = props.dashboardPart;
      var viewMode = props.viewMode;
      var disabled = props.disabled;
      var localization = props.localization;

      if (viewMode || dashboardPart.isBackSide || disabled) {
        return null;
      }
      if (!this.state.editMode) {
        return (
          <a
            className="btn btn-default u_noBorderAll"
            title={localization.getText('DASHBOARD_TITLE_EDIT_REPORT_PART_NAME')}
            onClick={this.editName}
          >
            <i className="icon-pencil-new" />
          </a>
        );
      }
      return (
        <span>
          <a
            className="btn btn-default u_noBorderAll"
            title={localization.getText('DASHBOARD_TITLE_SET_NEW_DASHBOARD_PART_NAME')}
            onClick={this.renamePart}
          >
            <i className="icon-ok success-color" />
          </a>
          <a
            className="btn btn-default u_noBorderAll"
            title={localization.getText('DASHBOARD_TITLE_REVERT_DASHBOARD_PART_NAME')}
            onClick={this.viewName}
          >
            <i className="icon-cancel" />
          </a>
        </span>
      );
    },

    /**
     * update input title
     * @method updateInputTitle
     * @param  {sting}         newName  New Name
     */
    updateInputTitle: function(newName) {
      this.props.dashboardPart.setEditingTitle(newName);
    },

    /**
     * rename dashboard part name
     */
    renamePart: function() {
      var dashboardPart = this.props.dashboardPart;
      var dashboardDetail = this.props.dashboardDetail;

      return this.props.validation.validate('inputTitle_' + dashboardPart.id).then(
        function(success) {
          if (success) {
            dashboardDetail.renameDashboardPart(dashboardPart, trim(dashboardPart.editingTitle));
            if (!dashboardPart.isBackSide) {
              this.setState({ editMode: false });
            }
          }
        }.bind(this)
      );
    },

    /**
     * switch to view mode
     * @method viewName
     */
    viewName: function() {
      var dashboardPart = this.props.dashboardPart;

      dashboardPart.setEditingTitle(dashboardPart.title);
      this.setState({ editMode: false });
    },

    /**
     * swtich to edit mode
     * @method editName
     */
    editName: function() {
      this.setState({ editMode: true });
    }
  });

  module.exports = connect()(NameInput);
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Header/Izenda.NameInput.jsx